<template>
  <div class="HomeJobstream">
    <Title type="small">Nous sommes</Title>
    <Title :uppercase="false">JobStream</Title>
    <Spacer></Spacer>
    <Spacer></Spacer>
    <div class="HomeJobstream-Text">
      <Paragraph><strong>JobStream</strong> est un cabinet de conseil en Ressources Humaines et un organisme de
        formation crée en 2017 par Gilles Vigné.
        En septembre 2020, Pascal Philippe en a pris la direction.
        Le cabinet est composé de consultants experts en ressources humaines et formation professionnelle.
        <strong>JobStream</strong> est une entité du Groupe IP ce qui nous procure une dimension nationale et un fort
        ancrage sur
        les territoires où nous opérons.
      </Paragraph>
    </div>
    <div class="HomeJobstream-Button Button">
      <router-link to="/nous-connaitre/jobstream" @click.native="$scrollToTop();">
        <Animation>
          <Button>Voir plus</Button>
        </Animation>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeJobstream"
}
</script>

<style scoped>
/* 
* Global 
*/
.HomeJobstream {
  text-align: center;
  max-width: 800px;
  margin: auto;
  padding: 100px 0;
}

.HomeJobstream >>> .Paragraph {
  padding: 0 25px;
}

a {
  text-decoration: none;
  color: white;
}


/* 
* Button
*/
.HomeJobstream-Button {
  margin: 50px auto auto auto;
}

.HomeJobstream-Button >>> .Button {
  text-align: center;
  width: 100px;
}

.HomeJobstream-Button a {
  display: inline-block;
}
</style>